import VisibleComponent from '../VisibleComponent'
import './index.less'
import Star from "../Star";
import Icon from "../Icon";
import Button from "../Button";
import Ad from "../Ad";
import Text from "../Text";

const template = `
    <div class="container mtg-simple-banner mtg-simple-banner-wrap">
        <div class="info">
                <div class="icon-box"></div>
                <div class="info-content">
                    <div class="info-other">
                        <div class="title-box"></div>
                        <div class="desc-box"></div>
                        <div class="rate-box"></div>
                    </div>
                    <div class="install-box"></div>
                </div>
            </div>
        <div class="mask"></div>
    </div>
`

/**
 * 简单banner类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class SimpleBanner extends VisibleComponent {
    constructor(options = {}) {
        super(options)

        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)

        this.containerBox = this.element.querySelector('.container')
        this.maskBox = this.element.querySelector('.mask')
        this.iconBox = this.element.querySelector('.icon-box')
        this.buttonBox = this.element.querySelector('.install-box')
        this.titleBox = this.element.querySelector('.title-box')
        this.descBox = this.element.querySelector('.desc-box')
        this.rateBox = this.element.querySelector('.rate-box')
        this.render(options)
    }

    render(options) {
        const {
            icon,
            buttonText = 'Install',
            title,
            desc,
            rating,
            background,
            onClick,
            onIconClick,
            onButtonClick,
        } = options

        onClick && this.onClick(onClick)
        // 设置背景色
        switch (background) {
            case "white":
                this.maskBox.style.backgroundColor = "#fff";
                break;
            case "black":
                this.maskBox.style.backgroundColor = "#000";
                this.maskBox.style.opacity = "25%";
                break;
            default:
                this.maskBox.style.backgroundColor = "#fff";
        }
        if (icon) {
            const iconComp = new Icon({
                url: options.icon,
                onClick: onIconClick
            })
            iconComp.appendTo(this.iconBox)
        }
        const cta = new Button({
            type: "cta",
            text: buttonText,
            onClick: onButtonClick
        })
        cta.appendTo(this.buttonBox);
        if (title) {
            const titleComp = new Text({
                text: title,
                type: "title"
            })
            titleComp.appendTo(this.titleBox)
        }
        if (desc) {
            const descComp = new Text({
                text: desc,
                type: "desc"
            })
            descComp.appendTo(this.descBox);
        }
        const starComp = new Star({
            star: rating
        })
        starComp.appendTo(this.rateBox);
        const ratingComp = new Text({
            text: rating,
            type: "rating"
        })
        ratingComp.appendTo(this.rateBox);
        const ad = new Ad()
        ad.appendTo(this.containerBox);
    }

    appendTo(target) {
        return new Promise(resolve => {
            if(target instanceof HTMLElement){
                target.appendChild(this.element)
            }else if(target instanceof VisibleComponent){
                target.element.appendChild(this.element)
            }
            resolve()
        })
    }
}

export default SimpleBanner